// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { DecisionTreeNode } from '../../SagaBase/DecisionTreeNode';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class DecisionNode_abstract extends DecisionTreeNode {
  static $t: string = 'SagaBase.DecisionNode';
  $t: string = 'SagaBase.DecisionNode';

  public static GetMembers(): string[] {
    return ['State', 'StateSpecified', 'Outputs', 'OutputsSpecified'].concat(DecisionTreeNode.GetMembers());
  }

  public GetMembers(): string[] {
    return DecisionNode_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public State: any;
  public StateSpecified: boolean = false;
  public Outputs: any[];
  public OutputsSpecified: boolean = false;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
